// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  Current: (t, data?, options?) => t('enum.subscription-state.current.name', data, options),
  Expired: (t, data?, options?) => t('enum.subscription-state.expired.name', data, options),
  ExpiringSoon: (t, data?, options?) => t('enum.subscription-state.expiring-soon.name', data, options),
  None: (t, data?, options?) => t('enum.subscription-state.none.name', data, options),
  Recurring: (t, data?, options?) => t('enum.subscription-state.recurring.name', data, options),
  /* eslint-enable max-len */
};

export const description: ITranslationTable = {
  /* eslint-disable max-len */
  Current: (t, data?, options?) => t('enum.subscription-state.current.description', data, options),
  Expired: (t, data?, options?) => t('enum.subscription-state.expired.description', data, options),
  ExpiringSoon: (t, data?, options?) => t('enum.subscription-state.expiring-soon.description', data, options),
  None: (t, data?, options?) => t('enum.subscription-state.none.description', data, options),
  Recurring: (t, data?, options?) => t('enum.subscription-state.recurring.description', data, options),
  /* eslint-enable max-len */
};
